import { Typography } from '@mui/material';
import React, { FC } from 'react';
import ViewBase from 'src/components/ViewBase';
import HeaderContent from './HeaderContent';
import Content from './Content';

const Reports: FC = () => {
  const Title = <Typography>דוחות</Typography>;

  return (
    <ViewBase Title={Title} HeaderContent={<HeaderContent />}>
      <Content />
    </ViewBase>
  );
};

export default Reports;
